import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { TdoDropdownChange } from './models/tdo-dropdown-change';
import { MatOptionSelectionChange } from '@angular/material/core';

@Component({
    selector: 'tdo-dropdown-v2',
    templateUrl: './tdo-dropdown-v2.component.html',
    styleUrls: ['./tdo-dropdown-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TdoDropdownV2Component implements AfterViewInit, OnChanges {
    @Input() datasource: any[] = [];

    @Input() displayProperty: string = '';
    @Input() isMultiSelect: boolean = false;
    @Input() isHideUnderline: boolean = false;
    @Input() value: object | number | null = null;
    @Input() isAutoSelectAll = false;
    @Input() allLabel: string = 'All';
    @Input() isIncludeAll: boolean = false;
    @Input() displayPredicate: any;
    @Input() id: string;
    @Input() isPreventMouseEventPropagation: boolean = false;
    @Input() placeholderPosition: string = ''; // above, before
    @Input() isRequired: boolean = false;
    @Input() widthString: string = '100%';
    @Input() selectClass: string = 'tdo-dropdown-v2-select';
    @Input() optionClass: string = 'tdo-dropdown-v2-option';
    @Input() isDisabled = false;

    @Input() placeholder: string = 'Select Item';

    @Input() innerDataSourcePropertyName: string = '';
    @Input() innerDataSourceDisplayName: string = '';
    @Input() isLoading: boolean = false;

    @Output() selectionChange = new EventEmitter<TdoDropdownChange>();
    @Output() closed = new EventEmitter<TdoDropdownChange>();

    selected: FormControl = new FormControl({ disabled: this.isDisabled });
    selectedItems: any[] = [];
    allObject: Object = {};
    isMultiSelectOpen = false;
    noFoundPlaceHolder: string;

    constructor() { }


    ngAfterViewInit() {
        if (this.constructor.name === 'TdoDropdownV2Component') {
            if (this.datasource && this.datasource.length == 0) {
                this.placeholder = 'No records found';
            }
            else
            {this.placeholder = this.noFoundPlaceHolder; }
        }

        if (this.isMultiSelect && this.isAutoSelectAll) {
            // @ts-ignore
            this.allObject[this.displayProperty] = this.allLabel;
            const a: Object[] = [];
            a.push(this.allObject);
            a.push(... this.datasource);
            // If each item has child items
            if (this.innerDataSourcePropertyName.length > 0) {

                for (const ds of this.datasource) {
                    for (const mod of ds[this.innerDataSourcePropertyName]) {
                        a.push(mod);
                    }
                }

            } 

            this.selected.setValue(a);
            const evt = new TdoDropdownChange();
            if (this.isAutoSelectAll) {
                evt.isAll = true;
            }
            evt.isMultiSelect = this.isMultiSelect;
            evt.value = this.selected.value;
            evt.isAll = true;
            this.closed.emit(evt);
        }
        else if (this.value) {
            this.selected.setValue(this.value);

            const evt = new TdoDropdownChange();
            evt.isMultiSelect = this.isMultiSelect;
            evt.value = this.value;
            evt.isUserInput = false;
            this.selectionChange.emit(evt);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.noFoundPlaceHolder === undefined) 
            this.noFoundPlaceHolder = this.placeholder;
        if (this.constructor.name === 'TdoDropdownV2Component') {
            if (this.datasource && this.datasource.length == 0) {
                this.placeholder = 'No records found';
            }
            else
            {this.placeholder = this.noFoundPlaceHolder; }
        }
        if (changes.value?.previousValue != changes.value?.currentValue && !this.isMultiSelect) {
            this.selected.setValue(this.value);
        }
    }

    onSelectionChange(event: MatSelectChange) {

        const evt = new TdoDropdownChange();
        evt.isMultiSelect = this.isMultiSelect;
        evt.value = event.value;
        this.selectionChange.emit(evt);
    }

    onClosed() {
        const evt = new TdoDropdownChange();
        evt.isMultiSelect = this.isMultiSelect;
        if (this.isMultiSelect) {
            this.isMultiSelectOpen = false;
            evt.value = this.selected.value;

            // Adjust to handle ALL CHILDREN AS WELL
            if (this.isIncludeAll) {
                if (evt.value.length >= this.datasource.length) {
                    evt.isAll = true;
                }
            }
        }
        evt.value = this.selected?.value;
        this.closed.emit(evt);
    }

    onParentSelectionChange(event: MatOptionSelectionChange, obj: any, subset: any[] = []) {
        if (!event.isUserInput) {
            return;
        }

        if (!event.isUserInput || !this.isMultiSelect) {
            return;
        }
        // If they have children

        let oldvalues = this.selected.value as object[];
        if (!oldvalues) {
            oldvalues = [];
        } else {
            oldvalues.push(obj);
        }
        if (this.innerDataSourcePropertyName.length > 0) {
            if (event.source.selected) {
                oldvalues.push(...subset);
                this.selected.setValue(oldvalues);
            } else {
                oldvalues = oldvalues.filter(p => !subset.includes(p) && !obj);
                this.selected.setValue(oldvalues);
            }
        }
    }

    onAllSelectionChange(event: MatOptionSelectionChange) {
        if (!event.isUserInput) {
            return;
        }
        if (event.source.selected) {
            const a: Object[] = [this.allObject, ... this.datasource];
            if (this.innerDataSourcePropertyName) {
                const children = this.datasource.map(p => p[this.innerDataSourcePropertyName]);
                for (const ds of this.datasource) {
                    for (const mod of ds[this.innerDataSourcePropertyName]) {
                        a.push(mod);
                    }
                }
            }
            this.selected.setValue(a);

            const evt = new TdoDropdownChange();
            evt.isMultiSelect = this.isMultiSelect;
            evt.value = this.datasource;
            this.selectionChange.emit(evt);
        } else {
            this.selected.setValue([]);
        }
    }

    onValueChange($event: any) {
    }

    onSelectionChildChange(event: MatOptionSelectionChange, innerObj: any) {
        if (!event.isUserInput) {
            return;
        }
        const evt = new TdoDropdownChange();
        evt.isMultiSelect = this.isMultiSelect;
        evt.value = event.source.value;
        this.selectionChange.emit(evt);
    }

    onSelectMouseDown(event: MouseEvent) {
        if (this.isPreventMouseEventPropagation) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    onOpened() {
        if (this.isMultiSelect) {
            this.isMultiSelectOpen = true;
        }
    }

    clearSelection() {
        this.selected.setValue([]);
    }
}
